import { getSystemDb, wakeLocalWrite } from '@firesquirrel/local-db';
import { writeAuditLog } from './systemAuditLogService';

export async function listTiers(): Promise<any[]> {
  const db = await getSystemDb();
  const docs = await db.tiers.toArray();
  return docs.sort((a: any, b: any) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}

export async function getTier(idOrCode: string): Promise<any | null> {
  const db = await getSystemDb();
  const doc = await db.tiers.get(idOrCode);
  if (!doc) {
    const all = await listTiers();
    const match = all.find((t: any) => t.code === idOrCode);
    return match ?? null;
  }
  return doc;
}

export async function upsertTier(data: any): Promise<void> {
  const db = await getSystemDb();
  const isNew = !(await db.tiers.get(data._id));
  await db.tiers.put({ ...data, updatedAt: new Date().toISOString() });
  wakeLocalWrite('tiers');
  writeAuditLog({
    collection: 'tiers',
    documentId: data._id,
    action: isNew ? 'create' : 'update',
    summary: isNew ? `Created tier "${data.code}"` : `Updated tier "${data.code}"`,
  }).catch((err) => {
    console.warn('[tierService] Failed to write audit log for tier upsert:', err);
  });
}

export function compareTiers(tier1: any, tier2: any): Record<string, any> {
  if (!tier1 || !tier2) return {};
  const keys = new Set([...Object.keys(tier1), ...Object.keys(tier2)]);
  const diff: Record<string, any> = {};
  for (const key of keys) {
    if (JSON.stringify(tier1[key]) !== JSON.stringify(tier2[key])) {
      diff[key] = { tier1: tier1[key], tier2: tier2[key] };
    }
  }
  return diff;
}
